<mat-card class="mb-2" *ngIf="data">
  <mat-card-content>
    <div class="card-header">
      <h3 class="info-title">{{data.title}}</h3>
      <a [target]="data.linkTarget" [href]="data.linkUrl" class="more-link">{{data.linkText}}</a>
    </div>

    <div class="carousel-wrap">
      <swiper-container
        pagination="true"
        pagination-clickable="true"
        [breakpoints]="breakpoints"
        class="carousel"
      >
        <swiper-slide *ngFor="let event of data.events">
          <app-event-item [event]="event" [atTimeText]="data.atTimeText" [upToText]="data.upToText" />
        </swiper-slide>
      </swiper-container>
    </div>
  </mat-card-content>
</mat-card>